import { DateTime } from 'luxon';
import { FC, useCallback, useMemo, useState } from 'react';
import { useInterval } from '@react-hooks-library/core';

export type Transaction = {
  id: string;
  dateISO?: string;
  link: string;
};

interface TransactionLinkProps {
  transaction: Transaction;
}

const TransactionLink: FC<TransactionLinkProps> = ({ transaction }) => {
  const truncatedId = `${transaction.id.substring(0, 6)}...${transaction.id.substring(transaction.id.length - 5, transaction.id.length - 1)}`;
  const [relativeTime, setRelativeTime] = useState<string | null>(null);

  const dateISO = useMemo(
    () => transaction?.dateISO ?? DateTime.now().toISO(),
    [transaction]
  );
  const updateTime = useCallback(
    () =>
      setRelativeTime(
        `– ${DateTime.fromISO(dateISO).toRelative({ base: DateTime.now() })}`
      ),
    []
  );
  useInterval(updateTime, 1000);

  return (
    <>
      <a href={transaction.link} target="_blank" rel="noreferrer">
        {truncatedId}
      </a>{' '}
      {relativeTime && (
        <div className="inline-block relative animate-fade-in">
          {relativeTime}
        </div>
      )}
    </>
  );
};

export default TransactionLink;
